import { render, staticRenderFns } from "./SideMenuHeader.vue?vue&type=template&id=1da635f4&scoped=true&"
import script from "./SideMenuHeader.vue?vue&type=script&lang=js&"
export * from "./SideMenuHeader.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuHeader.vue?vue&type=style&index=0&id=1da635f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da635f4",
  null
  
)

export default component.exports